// components/DateFild.js
import React from 'react';
import DatePicker from 'react-date-picker';
import { FaRegCalendarAlt, FaRedo } from "react-icons/fa";

// Format to DD/MM/YYYY
const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

// Parse from multiple string formats
const parseDate = (input) => {
    if (!input) return null;
    if (input instanceof Date && !isNaN(input)) return input;
    if (typeof input !== 'string') return null;

    // Handle DD/MM/YYYY
    if (input.includes('/')) {
        const [dd, mm, yyyy] = input.split('/');
        const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        if (!isNaN(date)) return date;
    }

    // Handle YYYY-MM-DD
    if (input.includes('-')) {
        const [yyyy, mm, dd] = input.split('-');
        const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        if (!isNaN(date)) return date;
    }

    return null;
};

const DateFild = ({ value, onChange }) => {
    const parsedDate = parseDate(value);

    const handleChange = (dateObj) => {
        const formatted = formatDate(dateObj);
        onChange(formatted); // Send DD/MM/YYYY to parent
    };

    return (
        <DatePicker
            onChange={handleChange}
            value={parsedDate}
            format="dd/MM/yyyy"
            clearIcon={<FaRedo />}
            calendarIcon={<FaRegCalendarAlt />}
            dayPlaceholder="dd"
            monthPlaceholder="mm"
            yearPlaceholder="yyyy"
        />
    );
};

export default DateFild;
